import { defineStore } from "pinia";

const useLyricsTranslatorDataStore = defineStore({
  id: "lyricsTranslatorDataStore",
  state: () => {
    return {
      initData: {

      },
      beforeClosedData: {

      }
    }
  },
  actions: {
    setInitData(data) {
      this.initData = data
    },
    setBeforeClosedData(data) {

    },
    reset() {
      this.initData = {}
      this.beforeClosedData = {}
    }
  }
})

export default useLyricsTranslatorDataStore;